// Mirror of the LocalizedString type + helper from
// src/types/localized-string.ts. Phase 2 these collapse into
// @pontimed/types.

export type LocalizedString = {
  ro: string;
  en: string;
  bg?: string;
  de?: string;
  fr?: string;
  it?: string;
  es?: string;
  cs?: string;
  hu?: string;
  hr?: string;
  sr?: string;
  el?: string;
  _auto?: string[];
  _original?: string;
  [key: string]: string | string[] | undefined;
};

export function tLocalized(field: LocalizedString | null | undefined, locale: string): string {
  if (!field) return "";
  return (
    (field[locale] as string) ||
    field.en ||
    field.ro ||
    (Object.values(field).find((v) => typeof v === "string" && v.length > 0) as string) ||
    ""
  );
}
